import React from 'react'
import { useTranslation } from 'react-i18next';

const FooterBottom = () => {
  const { i18n } = useTranslation();
  return (
    <div className="w-full py-10" style={{diection : i18n.language === 'at' ? 'rtl' : 'ltr'}}>
      {i18n.language === 'en' ? (
        <p className="text-center text-gray-500 text-base">
          © 2025. All rights reserved by Moayad Samir Ismail
        </p>
      ) : (
        <p className="text-center text-gray-500 text-base">
          ٢٠٢٥  جميع الحقوق محفوظة لمؤيد سمير إسماعيل ©
        </p>
      )}
    </div>
  );
}

export default FooterBottom